import React from 'react';
import { GridTable } from 'components/reports/base/GridTable';
import styles from '../../styles/components/reports/base/GridTableReport.module.css';
import { RankResults } from 'model/reports/RanksData';
import _ from 'lodash';

export interface RanksTableReportData {
  report: RankResults;
}

export const RanksTableReport: React.FC<any> = ({ report }) => {
  return (
    <GridTable
      wideColumn={true}
      cols={_.map(report.labels, (_, i) => (
        <span className={styles.headerItem}>{i + 1}</span>
      ))}
      rows={_.map(report.labels, rl => {
        const rowElem = (
          <div>
            <span className={styles.tableItem}>{rl}</span>
            <span className={styles.measurements}>Count (Column %)</span>
          </div>
        );
        return rowElem;
      })}
      elementRenderer={(colIndex: number, rowIndex: number) => {
        const value = _.find(
          report.data,
          d => d.order === colIndex && d.index === rowIndex
        );
        if (value) {
          const data = _.find(
            report.countData,
            d => d.data.index === value.index && d.data.order === value.order
          );
          return (
            <span
              className={styles.tableItem}
            >{`${data.count} (${data.percent}%)`}</span>
          );
        } else {
          return <span className={styles.tableItem}>0</span>;
        }
      }}
    />
  );
};
